import { forwardRef, type SVGProps } from 'react';

export interface TextAlignCenterIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const TextAlignCenterIcon = forwardRef<SVGSVGElement, TextAlignCenterIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M12.6665 12.104C12.9772 12.104 13.229 12.3558 13.229 12.6665C13.2289 12.9771 12.9771 13.229 12.6665 13.229H3.3335C3.02289 13.229 2.77108 12.9771 2.771 12.6665C2.771 12.3558 3.02284 12.104 3.3335 12.104H12.6665ZM11.3335 7.43701C11.644 7.4371 11.8959 7.68898 11.896 7.99951C11.896 8.31012 11.6441 8.56192 11.3335 8.56201H4.6665C4.35592 8.56192 4.104 8.31012 4.104 7.99951C4.10409 7.68898 4.35597 7.4371 4.6665 7.43701H11.3335ZM14 2.77051C14.3107 2.77051 14.5625 3.02235 14.5625 3.33301C14.5625 3.64367 14.3107 3.89551 14 3.89551H2C1.68934 3.89551 1.4375 3.64367 1.4375 3.33301C1.4375 3.02235 1.68934 2.77051 2 2.77051H14Z"
      fill="currentColor"
    />
  </svg>
));

TextAlignCenterIcon.displayName = 'TextAlignCenterIcon';
